import { BrowserRouter } from "react-router-dom";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import { ThemeProvider } from "./components/theme/theme-provider";
import { Routes } from "./routes";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider defaultTheme="system">
        <div className="min-h-screen flex flex-col bg-background text-foreground antialiased">
          <Navbar />
          <main className="flex-1 flex flex-col">
            <Routes />
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
